import { useEffect, useState } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function DashboardPage() {
  const [user, setUser] = useState(null);
  const [showApiKey, setShowApiKey] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get("https://mbmailer.mb-techs.com/mbmailer/auth/me", {
        withCredentials: true, // or use Bearer token if JWT in headers
      })
      .then((res) => {
        setUser(res.data);
        setLoading(false);
      })
      .catch((err) => {
        toast.error("Failed to load user info");
        setLoading(false);
      });
  }, []);

  const regenerateKey = async () => {
    if (
      !window.confirm(
        "Are you sure you want to regenerate your API key? This will break any existing forms using the old one."
      )
    )
      return;
    try {
      const res = await axios.post(
        "https://mbmailer.mb-techs.com/mbmailer/auth/regenerate-api-key",
        {},
        {
          withCredentials: true,
        }
      );
      setUser((prev) => ({ ...prev, apiKey: res.data.apiKey }));
      setShowApiKey(true);
      toast.success("✅ New API key generated");
    } catch {
      toast.error("❌ Failed to regenerate API key");
    }
  };

  if (loading)
    return <div className="text-center mt-20 text-white">Loading...</div>;

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center px-4">
      <div className="w-full max-w-xl bg-white p-8 rounded-lg shadow text-center">
        <h1 className="text-2xl font-bold mb-4">Welcome, {user?.name}</h1>

        <div className="my-6">
          <p className="text-gray-700 text-sm mb-2">Your API Key:</p>
          {showApiKey ? (
            <div className="bg-gray-100 text-gray-800 px-4 py-2 rounded break-all border border-gray-300">
              {user.apiKey}
            </div>
          ) : (
            <div className="text-gray-400 italic">Hidden for security</div>
          )}

          <div className="flex justify-center gap-4 mt-4">
            <button
              onClick={() => setShowApiKey(!showApiKey)}
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded transition"
            >
              {showApiKey ? "Hide Key" : "View Key"}
            </button>
            <button
              onClick={regenerateKey}
              className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded transition"
            >
              Regenerate Key
            </button>
          </div>
        </div>

        <p className="text-sm text-gray-500 mt-8">
          Keep this key private. It allows your forms to send data through
          MBMailer.
        </p>
        <ToastContainer position="top-center" autoClose={3000} />
      </div>
    </div>
  );
}
